import {
  shape,
  string,
  number
} from 'prop-types';

export default shape({
  city: number.isRequired,
  bikeType: number.isRequired,
  bikeTypeName: string.isRequired,
  beginTime: string.isRequired,
  endTime: string.isRequired
});



// WEBPACK FOOTER //
// ./src/utils/shapes/OrderInfo.js